import { Injectable, Inject } from '@angular/core';
import { RedireccionMenu } from '../../models/menu/redireccion-menu.class';
import { OpcionVentana } from '../../contants/opcion-ventana.constant';
import { AgenteService } from '../agente/agente.service';
import { Router } from '@angular/router';
import { Asesor } from '../../models/agente/asesor.class';
import { Auxiliar } from '../../models/agente/auxiliar.class';
import { Delegado } from '../../models/agente/delegado.class';
import { Configuracion } from '../../contants/configuracion.constant';
import { Pais } from '../../contants/pais.constant';
import { GrupoPersona } from '../../contants/grupo-persona.constant';
import { FiltroAgente } from '../../models/filtro/filtro-agente';
import { CookieService } from 'ngx-cookie';
import { DetalleOpcion } from '../../models/menu/detalle-opcion.class';
import { HttpCustom } from '../http/http-custom.service';
import { UrlService } from '../../contants/url-service.constant';
import { FiltroIdeoneidad } from '../../models/filtro/filtro-idoneidad';
import { AgenteIdoneo } from '../../models/agente/agente-idoneo.class';
import { WINDOW } from '../window/window.service';
import { DialogService } from '../dialog/dialog.service';
// tslint:disable-next-line:max-line-length
import { MensajeInformativoDialogComponent } from '../../components/shared/dialogs/mensaje-informativo-dialog/mensaje-informativo-dialog.component';
import * as msg from '../../../assets/msg/message.json';
import { HeaderPeticion } from '../../models/http/headerPeticion.class';




@Injectable()
export class RedireccionService {

  redireccion: RedireccionMenu = null;

  constructor(private agenteService: AgenteService, private dialogService: DialogService,
    private router: Router, private cookieService: CookieService,
    private httpCustom: HttpCustom, @Inject(WINDOW) private window: Window) { }


  getRedireccionMenu() {
    return this.redireccion;
  }

  setRedireccionMenu(redireccionMenu: RedireccionMenu) {
    this.redireccion = redireccionMenu;
  }

  ejecutarRedireccion(opcionMenu: RedireccionMenu) {
    if (opcionMenu.isLocal) {
      this.redireccionLocal(opcionMenu);
    } else {
      this.redireccionExterna(opcionMenu);
    }

  }


  validarIdoneidad(detalleOpcion: DetalleOpcion): Promise<AgenteIdoneo> {
    return new Promise((resolve, reject) => {
      this.httpCustom.postServiceWithHeaders(UrlService.VALIDAR_IDEONEIDA, this.cargarFiltroIdoneidad(detalleOpcion), [new HeaderPeticion(Configuracion.HEADER_DESCRIPCION_PETICION, 'Validando Información de Idoneidad')]).subscribe(
        result => {
          if (result !== null && result.length > 0) {
            resolve(result[0]);
          } else {
            resolve(null);
          }
        },
        error => {
          return reject(null);
        }
      );

    });
  }


  cargarFiltroIdoneidad(detalleOpcion: DetalleOpcion): any[] {
    return [new FiltroIdeoneidad(this.agenteService.getDniAgente(),
      (this.agenteService.getCodigoAgente() === null ?
        [this.agenteService.getUsuarioAgente()] : [this.agenteService.getCodigoAgente()]),
      detalleOpcion.ramo, detalleOpcion.subRamo,
      detalleOpcion.producto, detalleOpcion.operacion, detalleOpcion.aplicacion,
      detalleOpcion.accion, detalleOpcion.compania, detalleOpcion.pais)];
  }



  redireccionLocal(redireccionMenu: RedireccionMenu) {
    this.router.navigate([redireccionMenu.url]);
  }

  redireccionExterna(redireccionMenu: RedireccionMenu) {
    if (redireccionMenu.isLogout) {
      this.logout();
    } else {
      switch (redireccionMenu.opcionVenta) {
        case OpcionVentana.REDIRECCION_DIRECTA_NUEVA_PESTANA:
          this.redireccionNuevaPestana(redireccionMenu.url.toString());
          break;
        case OpcionVentana.AUTOS_PANAMA:
          this.redireccionAutosPanama(redireccionMenu);
          break;
        case OpcionVentana.REDIRECCION_DIRECTA_COTIZADOR:
          this.redireccionLocation(this.agregarContextPathCotizador(redireccionMenu.url));
          break;
        case OpcionVentana.REDIRECCION_DIRECTA_COTIZADORES:
          this.redireccionLocation(this.agregarContextPathCotizadores(redireccionMenu.url));
          break;
        case OpcionVentana.REDIRECCION_DIRECTA_COTIZADOR_PA:
          this.redireccionLocation(this.getUrlDirectaCotizadorPa(redireccionMenu.url.toString()));
          break;
        case OpcionVentana.PUBS_COTIZADOR_CONECTADO:
          this.redireccionNuevaPestana(this.agregarContextPathCotizador(redireccionMenu.url));
          break;
        case OpcionVentana.REDIRECCION_DIRECTA:
          this.redireccionLocation(redireccionMenu.url.toString());
          break;
        case OpcionVentana.REDIRECCION_DIRECTA_PARAMETROS:
          this.redireccionExternaParametroAsesorCodificado(redireccionMenu.url.toString());
          break;
        case OpcionVentana.REDIRECCION_DIRECTA_PARAMETROS_DECODIFICADOS:
          this.redireccionExternaParametroAsesorDecodificado(redireccionMenu.url.toString());
          break;

        default:
          break;
      }
    }
  }


  cleanDataCliente() {

  }


  getUrlDirectaCotizadorPa(url: String) {
    return (Configuracion.REDIRECCION_COTIZADOR_FORMATOSV2 === url.toString() ? url.toString() :
      this.isredireccionPanama() ?
      Configuracion.REDIRECCION_COTIZADOR_CONECTADO + '?country=pa&urlRedireccion=%3Fcountry%3Dpa%23' + url :
      Configuracion.REDIRECCION_COTIZADOR_CONECTADO + '?urlRedireccion=%23' + url);
  }

  agregarContextPathCotizador(url: String): string {
    return Configuracion.CONTEXT_PATH_COTIZADOR.concat(url.toString());
  }


  agregarContextPathCotizadores(url: String): string {
    sessionStorage.removeItem('CLIENTE');
    return Configuracion.CONTEXT_PATH_COTIZADORES.concat(url.toString());
  }

  agregarContextPathCotizadoresContinueTo(url: String): string {
    return Configuracion.CONTEXT_PATH_LOGIN_COTIZADOR_CONTINUE_TO.concat(
      Configuracion.CONTEXT_PATH_COTIZADORES_CONTINUE_TO.concat(url.toString()));
  }

  redireccionAutosPanama(redireccionMenu: RedireccionMenu) {
    const filtroAgente: FiltroAgente = this.agenteService.getFiltroAgente();
    let url = redireccionMenu.url;
    url = url.replace('{a}', filtroAgente.codAsesor.toString());
    url = url.replace('{d}', filtroAgente.loginAsesor.toString());
    this.redireccionNuevaPestana(url);
  }

  redireccionProducto(dniCliente: string) {
    let urlRedireccion: String = this.redireccion.url;
    const agente: Asesor | Auxiliar | Delegado = this.agenteService.getAgente();
    // tslint:disable-next-line:max-line-length

    // Al pasar por el panel de cliente, puedo querer ir a una URL externa y mandar los parámetros codificados o decodificados
    switch (this.redireccion.opcionVenta) {
      // Codificados
      case OpcionVentana.CONSULTA_REGISTRA_CLIENTE_EXTERNO_PARAMETROS_CODI: {
        urlRedireccion = urlRedireccion.replace('{c}', encodeURIComponent(btoa(dniCliente)));
        urlRedireccion = urlRedireccion.replace('{a}', this.obtenerInfoAsesorParametro(agente));
        break;
      }
      // Decodificados
      default: {
        urlRedireccion = urlRedireccion.replace('{c}', dniCliente);
        urlRedireccion = urlRedireccion.replace('{a}', this.obtenerInfoAsesorParametro(agente));
      }
    }

    this.agenteService.asesorIsProteccion().then(respuesta => {
      // Esto no se codifica
      urlRedireccion = urlRedireccion.replace('{PRT}', respuesta);
      if (this.redireccion !== null) {
        this.redireccionLocation(this.getUrlRedireccionProducto(urlRedireccion));
      }
    }).catch(error => {
      // Error en el servicio de asesor protección
      this.dialogService.open(MensajeInformativoDialogComponent, {
        mensaje: (<any>msg).msgAsesor.errorAsesorProteccion
      });
    });
  }

  redireccionExternaParametroAsesorCodificado(url:  String) {
    const agente: Asesor | Auxiliar | Delegado = this.agenteService.getAgente();
    url = url.replace('{a}', encodeURIComponent(btoa(this.obtenerInfoAsesorParametro(agente))));
    this.redireccionLocation(url);
  }

  redireccionExternaParametroAsesorDecodificado(url:  String) {
    const agente: Asesor | Auxiliar | Delegado = this.agenteService.getAgente();
    url = url.replace('{a}', this.obtenerInfoAsesorParametro(agente));
    this.redireccionLocation(url);
  }

  getUrlRedireccionProducto(urlRedireccion) {
    let urlRedireccionCompleta = '';
    switch (this.redireccion.opcionVenta) {
      case OpcionVentana.CONSULTAR_REGISTRA_CLIENTE_NOTIFICA_AYV:
      case OpcionVentana.CONSULTA_REGISTRA_CLIENTE_CS: {
        urlRedireccionCompleta = this.agregarContextPathCotizadores(urlRedireccion);
        break;
      }
      case OpcionVentana.CONSULTA_REGISTRA_CLIENTE_CS_CT: {
        urlRedireccionCompleta = this.agregarContextPathCotizadoresContinueTo(urlRedireccion);
        break;
      }
      case OpcionVentana.CONSULTA_REGISTRA_CLIENTE_EXTERNO_PARAMETROS_DECO: {
        urlRedireccionCompleta = urlRedireccion;
        break;
      }
      case OpcionVentana.CONSULTA_REGISTRA_CLIENTE_EXTERNO_PARAMETROS_CODI: {
        urlRedireccionCompleta = urlRedireccion;
        break;
      }
      default: {
        urlRedireccionCompleta = this.agregarContextPathCotizador(urlRedireccion);
        break;
      }
    }
    return urlRedireccionCompleta;
  }


  redireccionAYV(tipoDocumento: string, numeroDocumento: string) {
    const urlRedireccion: String = this.redireccion.url;
    this.ejecutarRedireccionAYV(this.agregarContextPathCotizadores(urlRedireccion), tipoDocumento, numeroDocumento);
  }


  redireccionAYVEstatica(tipoDocumento: string, numeroDocumento: string) {
    const urlRedireccion: String = Configuracion.REDIRECCION_ASESORIA_Y_VENTA;
    this.ejecutarRedireccionAYV(urlRedireccion, tipoDocumento, numeroDocumento);
  }

  ejecutarRedireccionAYV(urlRedireccion: String, tipoDocumento: string, numeroDocumento: string) {
    urlRedireccion = urlRedireccion.replace('{AMB}', location.protocol + '//' + location.host);
    urlRedireccion = urlRedireccion.replace('{TPL}', this.obtenerCadenaIngresoAYV());
    urlRedireccion = urlRedireccion.replace('{TD}', tipoDocumento);
    urlRedireccion = urlRedireccion.replace('{ND}', numeroDocumento);
    this.agenteService.asesorIsProteccion().then(respuesta => {
      urlRedireccion = urlRedireccion.replace('{PRT}', respuesta);
      this.redireccionLocation(urlRedireccion);
    }).catch(error => {
      // Error en el servicio de asesor protección
      this.dialogService.open(MensajeInformativoDialogComponent, {
        mensaje: (<any>msg).msgAsesor.errorAsesorProteccion
      });
    });
  }


  obtenerCadenaIngresoAYV(): string {
    const agente: Asesor | Auxiliar | Delegado = this.agenteService.getAgente();
    return (agente instanceof Asesor || agente instanceof Delegado) ? 'login-asesor' : 'login-auxiliar';
  }


  redireccionProductoGWT(tipo: string, numero: string) {
    let urlRedireccion: String = this.redireccion.url;
    // tslint:disable-next-line:max-line-length
    urlRedireccion = urlRedireccion.replace('{TD}', tipo);
    urlRedireccion = urlRedireccion.replace('{ND}', numero);

    this.redireccionLocation(this.agregarContextPathCotizador(urlRedireccion));
  }

  obtenerInfoAsesorParametro(agente: Asesor | Auxiliar | Delegado): string {

    let asesor = '';
    if (agente instanceof Asesor || agente instanceof Delegado) {
      asesor = agente.informacionComplementaria.asesor.codigo.toString();
    } else {
      asesor = agente.informacionBasica.dni.toString();
    }

    return asesor;
  }
  async logout() {
    const resultadoLogout: String = await this.agenteService.logoutAgente();
    if (resultadoLogout !== undefined || resultadoLogout !== null) {
      this.cookieService.removeAll();
      this.redireccionLocation(resultadoLogout);
    }
  }

  redireccionLocation(url: String) {
    let urlEnconde = encodeURIComponent(url.toString());
    this.window.location.href = decodeURIComponent(urlEnconde);
  }

  redireccionNuevaPestana(url: String) {
    this.window.open(url.toString(), '_blank');
  }

  optionMenuConsultaCliente(windowOptions: String): boolean {
    let consulta = false;
    if (windowOptions === OpcionVentana.CONSULTA_REGISTRA_CLIENTE ||
      windowOptions === OpcionVentana.CONSULTA_REGISTRA_CLIENTE_CS ||
      windowOptions === OpcionVentana.CONSULTA_REGISTRA_CLIENTE_EXTERNO_PARAMETROS_DECO ||
      windowOptions === OpcionVentana.CONSULTA_REGISTRA_CLIENTE_EXTERNO_PARAMETROS_CODI ||
      windowOptions === OpcionVentana.CONSULTA_REGISTRA_CLIENTE_CS_CT ||
      windowOptions === OpcionVentana.CONSULTAR_REGISTRA_CLIENTE_NOTIFICA_AYV ||
      windowOptions === OpcionVentana.CONSULTAR_CLIENTE_REDIRECCION_GWT ||
      windowOptions === OpcionVentana.CONSULTAR_CLIENTE_PN_REDIRECCION_GWT ||
      windowOptions === OpcionVentana.CONSULTAR_CLIENTE_REDIRECCION_GWT_AYV ||
      windowOptions === OpcionVentana.REDIRECION_AYV) {
      consulta = true;
    }

    return consulta;
  }


  optionMenuRegistraCliente(windowOptions: String): boolean {
    let consulta = false;
    if (windowOptions === OpcionVentana.CONSULTA_REGISTRA_CLIENTE ||
      windowOptions === OpcionVentana.CONSULTA_REGISTRA_CLIENTE_CS ||
      windowOptions === OpcionVentana.CONSULTA_REGISTRA_CLIENTE_EXTERNO_PARAMETROS_DECO ||
      windowOptions === OpcionVentana.CONSULTA_REGISTRA_CLIENTE_EXTERNO_PARAMETROS_CODI ||
      windowOptions === OpcionVentana.CONSULTA_REGISTRA_CLIENTE_CS_CT ||
      windowOptions === OpcionVentana.CONSULTAR_REGISTRA_CLIENTE_NOTIFICA_AYV) {
      consulta = true;
    }

    return consulta;
  }

  optionMenuNotificaAYV(windowOptions: String): boolean {
    let consulta = false;
    if (windowOptions === OpcionVentana.CONSULTAR_REGISTRA_CLIENTE_NOTIFICA_AYV ||
      windowOptions === OpcionVentana.CONSULTAR_CLIENTE_REDIRECCION_GWT_AYV) {
      consulta = true;
    }

    return consulta;
  }


  optionMenuRedireccionGWT(windowOptions: String): boolean {
    let consulta = false;
    if (windowOptions === OpcionVentana.CONSULTAR_CLIENTE_REDIRECCION_GWT ||
      windowOptions === OpcionVentana.CONSULTAR_CLIENTE_PN_REDIRECCION_GWT ||
      windowOptions === OpcionVentana.CONSULTAR_CLIENTE_REDIRECCION_GWT_AYV) {
      consulta = true;
    }

    return consulta;
  }

  optionMenuRedireccionAYVDirecta(windowOptions: String): boolean {
    let consulta = false;
    if (windowOptions === OpcionVentana.REDIRECION_AYV) {
      consulta = true;
    }

    return consulta;
  }

  obtenerCodigoPaisPorTipoRedireccion() {
    let codPais = Pais.CODIGO_COLOMBIA;
    if ((this.redireccion !== null &&
      OpcionVentana.CONSULTAR_CLIENTE_PN_REDIRECCION_GWT === this.redireccion.opcionVenta) ||
      (this.cookieService.get('CodCountry') !== undefined && atob(this.cookieService.get('CodCountry')) === 'P')) {
      codPais = Pais.CODIGO_PANAMA;
    }
    return codPais;
  }

  obtenerCodigoGrupoPersonaPorTipoRedireccion() {
    let codGrupo = GrupoPersona.DOCUMENTO_VALIDO_COLOMBIA;
    if ((this.redireccion !== null && OpcionVentana.CONSULTAR_CLIENTE_PN_REDIRECCION_GWT === this.redireccion.opcionVenta) ||
      (this.cookieService.get('CodCountry') !== undefined && atob(this.cookieService.get('CodCountry')) === 'P')) {
      codGrupo = GrupoPersona.DOCUMENTOS_INTERNACIONALES;
    }
    return codGrupo;
  }


  isredireccionPanama() {
    return (this.cookieService.get('CodCountry') !== undefined && atob(this.cookieService.get('CodCountry')) === 'P');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/redireccion/redireccion.service.ts